import { ModuleWithProviders, NgModule } from '@angular/core';
import { Environment, ENVIRONMENT_TOKEN } from '@environment';
import * as Stores from './stores';

const STORES = [Stores.AntipatternStore, Stores.AssetsStore, Stores.StudentStore, Stores.UserStore, Stores.ViewStore];

@NgModule({})
export class DataAccessSharedModule {
  static forRoot(environment: Environment): ModuleWithProviders<DataAccessSharedModule> {
    return {
      ngModule: DataAccessSharedModule,
      providers: [
        ...STORES,
        {
          provide: ENVIRONMENT_TOKEN,
          useValue: environment
        }
      ]
    };
  }
}
